(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["colby-custom-dimensions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('colby-custom-dimensions')) {
    class ColbyCustomDimensions extends HTMLElement {
      eventTarget = null;

      connectedCallback() {
        this.eventTarget = this.closest('.shopify-section, dialog');
        this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
        this.eventTarget?.addEventListener('change', this.handleOptionChange);
        this.syncFromVariantPicker();
      }

      disconnectedCallback() {
        this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
        this.eventTarget?.removeEventListener('change', this.handleOptionChange);
        this.eventTarget = null;
      }

      updatedCallback() {
        this.syncFromVariantPicker();
      }

      handleProductSelect = (event) => {
        if (!(event.target instanceof Element)) return;

        const variantPicker = event.target.closest('variant-picker');
        if (variantPicker?.dataset.productId !== this.dataset.productId) return;

        const selectedDimension = event.selectedOptions?.find(
          (option) => option.name.trim().toLowerCase() === 'dimensions'
        );
        if (selectedDimension) {
          this.setActive(this.isCustomValue(selectedDimension.value));
        } else {
          this.syncFromVariantPicker();
        }
      };

      handleOptionChange = (event) => {
        if (!(event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement)) return;
        const optionName = event.target instanceof HTMLSelectElement
          ? event.target.selectedOptions[0]?.dataset.optionName
          : event.target.dataset.optionName;
        if (optionName?.trim().toLowerCase() !== 'dimensions') return;

        const variantPicker = event.target.closest('variant-picker');
        if (variantPicker?.dataset.productId !== this.dataset.productId) return;

        this.setActive(this.isCustomValue(event.target.value));
      };

      syncFromVariantPicker() {
        const variantPicker = this.eventTarget?.querySelector(
          `variant-picker[data-product-id="${CSS.escape(this.dataset.productId)}"]`
        );
        const selectedDimension = variantPicker?.querySelector('[data-option-name="Dimensions"]:checked');

        this.setActive(
          selectedDimension instanceof HTMLInputElement || selectedDimension instanceof HTMLOptionElement
            ? this.isCustomValue(selectedDimension.value)
            : this.dataset.customSelected === 'true'
        );
      }

      isCustomValue(value) {
        const normalizedValue = value?.trim().toLowerCase();
        return normalizedValue === 'custom dimensions' || normalizedValue === 'custom';
      }

      setActive(active) {
        this.hidden = !active;

        for (const input of this.querySelectorAll('input')) {
          input.required = active;
          input.disabled = !active;
        }
      }
    }

    customElements.define('colby-custom-dimensions', ColbyCustomDimensions);
  }
  } catch(e) { console.error(e); }
})();

})();
